// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mind-body-heart-rate.svg';

export const MindBodyHeartRate = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
